"use strict";
/*!
 *
 * app.js
 *
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
require("polyfill");
// global.Promise = require('es6-promise').Promise;
/*** node_modules **/
require("jquery.easing");
require("slick-carousel");
require("toggle-aria");
require("jquery.simplyscroll.min");
/*** ./modules **/
var hasher_1 = __importDefault(require("hasher"));
var extend_link_1 = __importDefault(require("extend-link"));
var slide_scroll_1 = __importDefault(require("slide-scroll"));
var tel_handler_1 = __importDefault(require("tel-handler"));
require("swipe-elem");
require("toggler");
require("expander");
require("toggle-expander");
var stickyer_1 = __importDefault(require("stickyer"));
require("swipe-elem");
require("tab");
require("@fancyapps/fancybox");
var menu_1 = require("menu");
var objectFitImages = require('object-fit-images');
var accordion_1 = __importDefault(require("accordion"));
var nav_current_1 = __importDefault(require("nav-current"));
require("gallery");
var lh = "";
lh = location.href;
if (lh.match(/dcmsadm/)) {
}
else {
    hasher_1.default();
    $(function () {
        $(window).on('CSSLoad', function () {
            $('body').attr('aria-busy', 'false');
        });
        new nav_current_1.default('.l_global', {
            target: '.l_global_item'
        });
        menu_1.menu();
        menu_1.megamenu();
        new stickyer_1.default();
        new extend_link_1.default('.biggerlink, .common_pagelink_item, .common_cases');
        tel_handler_1.default();
        slide_scroll_1.default({
            easing: 'easeOutExpo',
            speed: 700,
            not: '.not_scroll, .l_menu_btn a, .common_tab_nav_item a, .l_global_item.-megamenu > a, .fpga_btn a, .common_btn.-fpga a, .common_local_btn a'
        });
        $('.common_swipe').not('.-sm').not('.-md').not('.-lg').swipeElem({
            width: 700
        });
        $('.common_swipe.-lg').swipeElem({
            width: 1000
        });
        $('.common_swipe.-md').swipeElem({
            width: 650
        });
        $('.common_swipe.-sm').swipeElem({
            width: 550
        });
        $('.common_tab').tab();
        $().fancybox({
            selector: '.common_fancy > a',
            animationEffect: 'fade',
            buttons: ['close'],
            keyboard: false,
            arrows: false,
            touch: false
        });
        $().fancybox({
            selector: '.fpga_btn > a',
            arrows: false,
            buttons: ['close']
        });
        $().fancybox({
            selector: '.common_btn.-fpga a',
            arrows: false,
            buttons: ['close']
        });
        accordion_1.default();
        // objectFitImages('img.objectfit, img.top_bg_img, img.top_howto_nav_bg_img', { watchMQ: true });
        objectFitImages('.common_objectfit > img', { watchMQ: true });
        objectFitImages('.common_case_img > img', { watchMQ: true });
        objectFitImages('.common_header > img', { watchMQ: true });
        objectFitImages('.common_box.-bg > img', { watchMQ: true });
        $('#zip2').on('keyup', function () {
            AjaxZip3.zip2addr('zip1', 'zip2', 'pref', 'addr');
        });
        if ($('#topMainvisFader').length) {
            $('#topMainvisFader').on('init', function () {
                $('#topMainvis').addClass('-inited');
            });
            $('#topMainvisFader').slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                fade: true,
                arrows: false,
                dots: false,
                autoplay: true,
                autoplaySpeed: 3000,
                speed: 2000,
                pauseOnFocus: false,
                pauseOnHover: false
            });
        }
        ;
        $('.fpga_outline_gallery').gallery({
            'main': '.fpga_outline_gallery_main',
            'thumb': '.fpga_outline_gallery_thumb'
        });
        $('.sol_iot_product_gallery').gallery({
            'main': '.sol_iot_product_gallery_main',
            'thumb': '.sol_iot_product_gallery_thumb'
        });
        $('.common_widget_slider').slick();
        $('.sol_megamenu_inner').on('scroll', function (e) {
            e.stopPropagation();
        });
        if ($('.ai_slider').length) {
            $('.ai_slider').slick();
        }
        ;
    });
}
;
